import { useState } from "react";
import { motion, useReducedMotion } from "framer-motion";
import { MIGRATION } from "../../constants/testIds";
import { fadeUp } from "../../lib/motion";
import { RemandateTab } from "../../components/migration/tools/RemandateTab";
import { IntegrationConnectTab } from "../../components/migration/tools/IntegrationConnectTab";
import { ArchetypeTab } from "../../components/migration/tools/ArchetypeTab";
import { ParallelRunTab } from "../../components/migration/tools/ParallelRunTab";
import { ChecklistTab } from "../../components/migration/tools/ChecklistTab";

const TABS = [
  { key: "remandate", label: "Re-mandate campaign" },
  { key: "integrations", label: "Integration connect" },
  { key: "archetype", label: "Archetype template" },
  { key: "parallel", label: "Parallel-run & go-live" },
  { key: "checklist", label: "Go-live checklist" },
];

// UX-P04 SCR-P04-20/30/40/50/60 - the 5 non-wizard Migration Studio utility screens, tabbed like
// Reports.jsx/Money.jsx already do elsewhere in the Owner Cockpit.
export default function MigrationTools() {
  const reducedMotion = useReducedMotion();
  const [tab, setTab] = useState("remandate");

  return (
    <div className="space-y-5 max-w-4xl" data-testid={MIGRATION.toolsPage}>
      <motion.div {...fadeUp(reducedMotion)}>
        <h1 className="text-2xl font-bold" style={{ color: "var(--scarlet-text)", letterSpacing: "-0.02em" }}>Migration tools</h1>
        <p className="text-sm mt-0.5" style={{ color: "var(--scarlet-text-secondary)" }}>Everything else a go-live needs, outside the wizard.</p>
      </motion.div>

      <div className="flex gap-1.5 flex-wrap">
        {TABS.map((t) => (
          <button
            key={t.key} data-testid={MIGRATION.toolsTab(t.key)} onClick={() => setTab(t.key)}
            className="text-sm font-medium rounded-[10px] px-3.5 py-1.5 transition-colors"
            style={tab === t.key ? { background: "var(--scarlet-accent)", color: "#fff" } : { background: "transparent", border: "1px solid var(--scarlet-hairline)", color: "var(--scarlet-text-secondary)" }}
          >
            {t.label}
          </button>
        ))}
      </div>

      {tab === "remandate" && <RemandateTab />}
      {tab === "integrations" && <IntegrationConnectTab />}
      {tab === "archetype" && <ArchetypeTab />}
      {tab === "parallel" && <ParallelRunTab />}
      {tab === "checklist" && <ChecklistTab />}
    </div>
  );
}
